module.exports = __webpack_public_path__ + "static/media/two-toed-artist.0f62b7a2.jpg";